import { render, staticRenderFns } from "./CommonCardAseguradora.vue?vue&type=template&id=c40dded2&scoped=true"
import script from "./CommonCardAseguradora.vue?vue&type=script&lang=js"
export * from "./CommonCardAseguradora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40dded2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
